var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawPayWithCreditCard77G6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.934,
    height: 333.927,
    viewBox: "0 0 800.934 333.927",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-580 -279.587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.571,562.886l-67.25,15.17s-13.713-1.561-.709-20.707c1.168-1.724,2.554-3.579,4.183-5.594l34.853-17.1-.324-2.3-7.42-52.332-2.869-20.255,21.875-20.336,4.176-3.885L602.6,486.895l-.4.731L579,529.573Z",
    transform: "translate(362.041 -30.509)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.812,550.759l-67.25,15.17a7.184,7.184,0,0,1-6.181-8.8,20.14,20.14,0,0,1,1.818-5.63,60.432,60.432,0,0,1,7.837-11.874l34.853-17.1-4.274-30.139-2.128-15.031-1.378-9.718-2.833-20,26.051-24.221L555.7,449.653l27.144,25.115-3.664,6.612-4.368,7.9-20.961,37.91-4.271,7.722Z",
    transform: "translate(356.934 -33.633)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.738,549.467s-25.2-1.677-34.623-18.725a30.67,30.67,0,0,1-3.29-18.4l-10.27-20.3-14.617-28.928-37.288-5.888-1.945,1.726-27.038,24.021-8.272,7.35-12.774,11.36-61.946,55.038a46.161,46.161,0,0,1-9.382,11.725A63.143,63.143,0,0,1,475,576.8c-11.82,6.859-29.489,12.191-54.9,9.391L286.164,621.837l-13.09-89.827,112.34-36.936L550.168,387.306l111.218,28.462L712.96,489Z",
    transform: "translate(306.926 -42.936)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(939.775 279.587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.515,607.591,425.55,721.423a31.871,31.871,0,0,1-40.621-19.4L329.616,545.587a31.871,31.871,0,0,1,19.4-40.621L670.984,391.132a31.871,31.871,0,0,1,40.621,19.4l55.309,156.434a31.871,31.871,0,0,1-19.4,40.621Z",
    transform: "translate(-327.798 -389.314)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.576,526.253l.293.828a30.4,30.4,0,0,1-18.535,38.794l-323.576,114.4a30.4,30.4,0,0,1-38.791-18.526l-.293-.828Z",
    transform: "translate(-314.457 -348.601)",
    fill: "#f2f2f2",
    opacity: 0.096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.012,510.687c-21.342,14.043-48.694,3.475-58.259-11.92l1.526-.867C362.447,486.577,389.428,492.887,401.012,510.687Z",
    transform: "translate(-323.351 -358.718)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.814,555.285c-5.224,1.847-9.926,1.761-13.981-.252-9.163-4.553-13.457-18.051-16.916-28.9-1.006-3.155-1.954-6.136-2.921-8.572l-.014-.038a19.425,19.425,0,0,1,11.771-24.663l43.306-15.311c5.217-1.845,9.915-1.761,13.96.252,9.161,4.546,13.463,18.041,16.921,28.883,1.006,3.162,1.961,6.149,2.93,8.588a19.437,19.437,0,0,1-11.766,24.7Zm-32.02-38.414c.988,2.5,1.945,5.5,2.959,8.678,3.344,10.5,7.507,23.567,15.937,27.756,3.618,1.8,7.7,1.85,12.479.161l43.294-15.307a17.5,17.5,0,0,0,10.606-22.211c-.981-2.465-1.943-5.482-2.962-8.677-3.347-10.495-7.513-23.558-15.94-27.741-3.614-1.795-7.693-1.846-12.464-.16l-43.3,15.31a17.491,17.491,0,0,0-10.6,22.189Z",
    transform: "translate(-256.715 -363.474)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.511,515.985a43.043,43.043,0,0,1-23.661,1.3c-11.47-2.515-21.883-9.366-27.165-17.87l-.529-.853,2.381-1.353c18.442-11.487,46.1-5.259,58.033,13.079l.523.8-.8.528A40.5,40.5,0,0,1,392.511,515.985Zm-48.64-16.745c5.173,7.687,14.8,13.834,25.393,16.16a40.217,40.217,0,0,0,30.148-4.866c-11.676-16.89-37.545-22.493-54.87-11.678Z",
    transform: "translate(-323.827 -358.957)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.762,609.576a16.012,16.012,0,0,1-16.282-2.7,20.029,20.029,0,0,1-6.552-18.513A16.069,16.069,0,0,1,383.212,575.9l57.7-20.4a16.1,16.1,0,0,1,16.6,2.611,20.029,20.029,0,0,1,6.54,18.513c-1.139,5.955-5.156,10.341-11.287,12.44l-57.7,20.4ZM383.57,577.819a14.181,14.181,0,0,0-9.749,10.9,18.043,18.043,0,0,0,5.9,16.679,14.193,14.193,0,0,0,14.68,2.254l57.725-20.411a14.211,14.211,0,0,0,10.022-10.979,18.042,18.042,0,0,0-5.9-16.679,14.255,14.255,0,0,0-14.693-2.264l-57.735,20.413-.265.092Z",
    transform: "translate(-314.767 -340.272)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.752,503.836l-18.19,6.432a4.823,4.823,0,1,1-3.216-9.1l18.19-6.432a4.823,4.823,0,1,1,3.216,9.1Z",
    transform: "translate(-254.268 -358.051)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.718,515.054l-18.19,6.432a4.823,4.823,0,0,1-3.216-9.1l18.19-6.432a4.823,4.823,0,0,1,3.216,9.1Z",
    transform: "translate(-253.089 -354.717)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.684,526.271l-18.19,6.432a4.823,4.823,0,0,1-3.216-9.1l18.19-6.432a4.823,4.823,0,1,1,3.216,9.1Z",
    transform: "translate(-251.91 -351.383)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.29,495.161l-18.19,6.432a4.823,4.823,0,1,1-3.216-9.1l18.19-6.432a4.823,4.823,0,0,1,3.216,9.1Z",
    transform: "translate(-246.973 -360.631)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.256,506.378l-18.19,6.432a4.823,4.823,0,1,1-3.216-9.1l18.19-6.432a4.823,4.823,0,0,1,3.216,9.1Z",
    transform: "translate(-245.794 -357.296)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.222,517.595l-18.19,6.431a4.823,4.823,0,1,1-3.216-9.1l18.19-6.432a4.823,4.823,0,1,1,3.216,9.1Z",
    transform: "translate(-244.616 -353.963)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 404.006,
    height: 1.929,
    transform: "translate(14.952 189.941) rotate(-19.45)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.515,607.591,425.55,721.423a31.871,31.871,0,0,1-40.621-19.4L329.616,545.587a31.871,31.871,0,0,1,19.4-40.621L670.984,391.132a31.871,31.871,0,0,1,40.621,19.4l55.309,156.434a31.871,31.871,0,0,1-19.4,40.621ZM349.662,506.781a29.939,29.939,0,0,0-18.227,38.164l55.309,156.434a29.939,29.939,0,0,0,38.163,18.227L746.873,605.771A29.939,29.939,0,0,0,765.1,567.608l-55.31-156.429a29.939,29.939,0,0,0-38.162-18.236Z",
    transform: "translate(-327.798 -389.314)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.03,216.988l-1.019-2.3,41.507-18.408,9.895-34.713L263.5,149.509l1.581-1.957,16.21,13.106L270.614,198.1Z",
    transform: "translate(638.483 305.543)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.47,541.57l-10.91,5.314-22,2.33a63.145,63.145,0,0,1-11.3,8.35l-19.294-.639-32.587-1.02,110.167-93.938,22.209,5.455S487.441,543.763,488.47,541.57Z",
    transform: "translate(337.662 -23.701)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.046,513.111c-2.892.557-6.062,1.018-9.566,1.371-18.087,1.808-56.32,4.212-59.692,4.381-22.646,1.066-36.884,1.053-36.884,1.053l-47.767,23.257-10.91,5.314-88.433,9.366L509.54,455.746l14.506,3.561,24.552,6.038,27.049,6.65,23.47,1.056,30.37,1.362,24.547,1.1a16.109,16.109,0,0,1,15.543,16.561C669.192,500.174,663.575,509.121,643.046,513.111Z",
    transform: "translate(336.995 -25.304)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.316,502.635c-.391-.12-9.614-3.021-12.54-11.139-1.968-5.458-.583-11.844,4.116-18.982l2.1,1.383c-4.235,6.432-5.533,12.062-3.857,16.73,2.488,6.93,10.833,9.576,10.916,9.6Z",
    transform: "translate(388.034 -20.984)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.006,
    height: 2.515,
    transform: "matrix(0.899, -0.438, 0.438, 0.899, 827.774, 515.679)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.073,139.377l59.862-23.609.923,2.34-51.73,20.4,43.964,8.212-.463,2.472Z",
    transform: "translate(636.181 297.355)",
    opacity: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPayWithCreditCard77G6);
export default __webpack_public_path__ + "static/media/undraw_pay-with-credit-card_77g6.59860dbf17c8463e3906504eb93dc181.svg";
export { ForwardRef as ReactComponent };